<template>
  <f7-list-item swipeout
                @swipeout:deleted="onDeleted"
                :header="training_slot.gym.name + ' - Eiland: ' + training_slot.power_rack"
                :title="training_slot.start_date_time + '-' + this.training_slot.stop_time"
                :footer="training_slot.gym.street + ' in ' + training_slot.gym.city"
                :text="stageLine"
                @click="showActions = true"
  >
    <!--        <template #media>-->
    <!--          <f7-icon f7="house"></f7-icon>-->
    <!--        </template>-->
    <!--
      THE DEAD SLOT H1 NAMES IS GONE — deleted rather than repurposed
      (41-UI-SPEC IC1 / H1). Its whole body was commented-out f7-chip markup,
      and framework7-vue 8.3.4 passes that slot UNCALLED in the media branch:
      components/list-item.js:131 has `slots[…] && slots[…]` where :135, the
      non-media path, correctly has `slots[…]()`. It renders nothing in exactly
      the mode this list now uses. Leaving it in place advertised an available
      slot to the next person who opened this file, on the one component where
      it is broken. Its name is spelled nowhere in this file on purpose, so the
      acceptance grep for it cannot match the prose that removed it.
    -->
    <template #after>
      <!--
        ONE TAP. No dialog, no sheet, no second step, and no confirmation
        prompt — "add a confirm dialog" is the reflex and it is wrong here.
        Confirming destroys nothing, and its only consequence (in phase 42) is
        that the member KEEPS their slot, so an accidental tap is harmless in
        the safe direction. A dialog would cost every member a second tap to
        protect against an outcome nobody is harmed by.

        There is no un-confirm and no undo either: D-41-02's rows are
        append-only and once a stage is confirmed its button is gone. The
        member can still cancel the booking through the actions sheet that
        already exists on this row.
      -->
      <f7-button v-if="canConfirm"
                 fill
                 type="button"
                 class="reservering-confirm-button"
                 :aria-label="confirmLabel"
                 :preloader="confirming"
                 :loading="confirming"
                 :disabled="confirming"
                 @click.stop="onConfirm">Bevestig</f7-button>
      <!--
        The icon RETURNS once the button is gone. Two glyphs competing in a
        `nowrap; flex-shrink: 0` region is what pushes the row title into
        ellipsis, so `v-else-if` rather than a second `v-if`.
      -->
      <f7-icon f7="calendar_today" v-else-if="isToday"></f7-icon>
    </template>

    <f7-actions id="reservations-actions" :opened="showActions" @actions:closed="showActions = false">
      <f7-actions-group>
        <f7-actions-button @click="openDoor">Open de deur</f7-actions-button>
        <f7-actions-button @click="openCalendar">Voeg toe aan kalender</f7-actions-button>
        <f7-actions-button @click="onDeleted" color="red">Annuleer</f7-actions-button>
      </f7-actions-group>
      <f7-actions-group>
        <f7-actions-button>Sluit</f7-actions-button>
      </f7-actions-group>
    </f7-actions>

    <f7-actions :opened="showCalendarPicker" @actions:closed="showCalendarPicker = false">
      <f7-actions-group>
        <f7-actions-label>Kies je kalender</f7-actions-label>
        <f7-actions-button @click="addToGoogleCalendar">Google Calendar</f7-actions-button>
        <f7-actions-button @click="addToAppleCalendar">Apple / iCal</f7-actions-button>
      </f7-actions-group>
      <f7-actions-group>
        <f7-actions-button>Annuleer</f7-actions-button>
      </f7-actions-group>
    </f7-actions>

    <f7-swipeout-actions right>
<!--      <f7-swipeout-button style="padding-right: 20px;" color="red" @click.stop="showWeightCalculator = true" :close="true">-->
<!--        <img src="/static/images/icons/weight-icon-001-brand7.svg" style="height: 40px; opacity: 0.7;">-->
<!--      </f7-swipeout-button>-->
<!--      <f7-swipeout-button :close="true" :delete="true">-->
<!--        Delete-->
<!--&lt;!&ndash;        <img src="/static/images/icons/weight-icon-001-brand7.svg" style="height: 40px; opacity: 0.7;">&ndash;&gt;-->
<!--      </f7-swipeout-button>-->
      <f7-swipeout-button close delete :confirm-text="confirmText">
        Annuleer
      </f7-swipeout-button>
    </f7-swipeout-actions>
  </f7-list-item>
</template>

<script>

  import moment from "moment";
  import { f7, f7ready } from 'framework7-vue';
  import { openGoogleCalendar, shareICS } from '@/js/calendar.js';

  /**
   * The six confirmation states the server can report, as a frozen vocabulary
   * rather than six string literals scattered through a switch.
   *
   * Same shape and same reason as `admin/news.vue`'s STATUS: a typo in a frozen
   * key is a reference error at build time, where a typo in a bare case label is
   * a branch that silently never matches — and an unmatched case here renders an
   * empty line on a booking the member is being asked to confirm.
   *
   * EVERY ONE OF THESE IS THE SERVER'S WORD. `ConfirmationProjection::for()` is
   * the single six-state machine (41-04) and the client re-derives none of it.
   */
  const STAGE_STATE = Object.freeze({
    NONE: 'none',
    ASK_OPEN: 'ask_open',
    ASK_OPEN_PARTLY_CONFIRMED: 'ask_open_partly_confirmed',
    CONFIRMED_MORE_TO_COME: 'confirmed_more_to_come',
    ALL_CONFIRMED: 'all_confirmed',
    CLOSED_UNCONFIRMED: 'closed_unconfirmed',
  });

  /** The two states in which a stage is open and unconfirmed — and only these. */
  const CONFIRMABLE_STATES = Object.freeze([
    STAGE_STATE.ASK_OPEN,
    STAGE_STATE.ASK_OPEN_PARTLY_CONFIRMED,
  ]);

  export default {
    components: {},

    props: ['training_slot'],

    emits: ['confirm'],

    mixins: [],

    data: function () {
      return {
        showActions: false,
        showCalendarPicker: false,

        /**
         * In-flight state for this row's confirm, and it lives ON THE BUTTON
         * (`:preloader`/`:loading`/`:disabled`) rather than in the app-wide
         * `app/show_loader` overlay — that overlay covers the navbar and
         * swallows the back gesture, for a request that concerns one row.
         */
        confirming: false,
      };
    },

    computed: {
      isToday() {
        return moment(this.training_slot.start).isSame(moment(), 'day');
      },
      /**
       * THE ONE READ OF THE ONE FLAG, and everything conditional in this file
       * reads THIS — never the payload again.
       *
       * 42-UI-SPEC S7 `partial`. Absent or null -> FALSE, deliberately and as
       * the stated default, not as whatever the compiler happens to reach.
       * Missing data must never be read as "release is on": that is the
       * direction that prints a lie, and D-42-04 exists precisely so the three
       * stages can disagree. The flag is PER STAGE and comes from the SERVER --
       * never a global setting, never inferred from the offsets, never assumed
       * uniform. `ConfirmationProjection::for()` resolves it from the stage the
       * projection itself named and sends `false` when there is no stage.
       *
       * `=== true` rather than a truthiness test: a hand-built payload can
       * carry the string '0', which is truthy, and the one direction this must
       * never fail in is towards "release is on".
       *
       * IT IS A COMPUTED, NOT A LOCAL, ON PURPOSE. `stageLine` and
       * `confirmLabel` both need it, and S3's rule is that the accessible name
       * "must never say more than the visible state does". The only way to
       * guarantee that structurally is ONE source that both read. A second read
       * of the payload in `confirmLabel` would be a second derivation, and two
       * derivations can disagree — at which point one of them is lying to a
       * screen reader.
       *
       * @returns {boolean} whether the stage now being asked for really releases
       */
      releasesForReal() {
        return this.training_slot.confirmations?.releases_for_real === true;
      },
      /**
       * ONE COMPUTED, SIX VARIANTS, and that is a contract rather than a style
       * preference. Six v-if branches in the template is six places for a
       * seventh state to fall through and render nothing at all — which is the
       * same reason NewsComposer.vue drives its eight visibility variants from
       * one computed.
       *
       * EVERY NUMBER HERE COMES FROM THE SERVER. `total` is the number of stages
       * that apply to THIS booking, which is not always three: a booking made
       * after a stage's fire time skips that stage (BOOK-08). A client that
       * hard-codes "van 3" reports "0 van 3" for a booking that can only ever
       * reach 2. `{total} === 1` is served by V2 and V5 and never renders
       * `1 van 1`, which the server's own state choice already guarantees —
       * `all_confirmed` rather than a counted variant.
       *
       * @returns {string} the line to render, or '' for "render nothing at all"
       */
      stageLine() {
        const c = this.training_slot.confirmations;

        // The admin dummy row (`dummyTrainingSlot()`, id "admin") never came
        // from the API and carries no confirmations, and any partial payload
        // lands here too. `{total}` absent is "no stage applies yet" — never
        // `undefined van undefined`.
        if (!c || !c.state) {
          return '';
        }

        // `vrijkomen`, not `annuleren` or `verwijderen`. The member-facing
        // vocabulary is vrijgeven/vrijkomen -- the word the shipped
        // NotificationCategory::Booking description already uses ("het vrijgeven
        // van een plek"). `annuleren` is reserved for what the member does
        // THEMSELVES (the Annuleer control at :26), and blurring the two is
        // exactly the confusion D-42-03 exists to prevent.
        const consequence = this.releasesForReal ? ', anders komt je plek vrij' : '';

        switch (c.state) {
          case STAGE_STATE.ASK_OPEN:
            return `Bevestig je training vóór ${c.deadline_label}${consequence}`;
          case STAGE_STATE.ASK_OPEN_PARTLY_CONFIRMED:
            // The VERB changes with the flag, not only the tail. `volgende vóór`
            // announces a schedule; once the stage really releases, the line has
            // to ASK -- `bevestig vóór {…}, anders komt je plek vrij`.
            return this.releasesForReal
              ? `${c.confirmed} van ${c.total} bevestigd · bevestig vóór ${c.deadline_label}${consequence}`
              : `${c.confirmed} van ${c.total} bevestigd · volgende vóór ${c.deadline_label}`;
          case STAGE_STATE.CONFIRMED_MORE_TO_COME:
            return `${c.confirmed} van ${c.total} bevestigd · volgende vraag op ${c.next_ask_label}`;
          case STAGE_STATE.ALL_CONFIRMED:
            return 'Bevestigd';
          case STAGE_STATE.CLOSED_UNCONFIRMED:
            return 'Niet bevestigd';
          default:
            // LOAD-BEARING. `none` (V1) is "render nothing at all — no line, no
            // placeholder, no dash", and making that the DEFAULT means a seventh
            // state the server might one day send degrades to silence rather
            // than to `undefined`.
            return '';
        }
      },
      /**
       * The button exists only while a stage is actually open and unconfirmed.
       *
       * In V1, V4, V5 and V6 it is ABSENT ENTIRELY — no greyed-out ghost, no
       * disabled stub. Absence is the state.
       */
      canConfirm() {
        const c = this.training_slot.confirmations;

        return !!c && CONFIRMABLE_STATES.includes(c.state);
      },
      /**
       * The accessible name: A SECOND COMPUTED ON THE SAME INPUTS, not a second
       * derivation of them. Both read the same server-supplied
       * `confirmed`/`total`. If they could disagree about which stage is
       * outstanding, one of them is wrong and the screen reader gets the wrong one.
       *
       * The VISIBLE label stays `Bevestig`. A sighted member reads it in the
       * context of the row it sits in — the date, the time, the gym and the stage
       * line are all within a few millimetres. A screen reader moving control by
       * control announces "Bevestig" and nothing else, and a member with several
       * outstanding bookings then cannot tell which one they are about to confirm.
       *
       * In V2 the stage index is omitted: with nothing confirmed there is no
       * ambiguity to resolve, and `moment 1 van 3` is the same noise IC2 already
       * forbids on screen.
       */
      confirmLabel() {
        const c = this.training_slot.confirmations || {};
        // Already formatted server-side — the client formats nothing new here.
        const when = this.training_slot.start_date_time;

        // S3, adopted verbatim from 41-UI-SPEC's reserved table: the accessible
        // name "tracks whatever V2/V3 become; must never say more than the
        // visible state does". The ONLY way to guarantee that is one source --
        // `releasesForReal` is the SAME computed `stageLine` reads, not a second
        // read of `c` and not a re-derivation. If the two could disagree about
        // whether release is on, one of them is lying to a screen reader.
        const consequence = this.releasesForReal ? ', anders komt je plek vrij' : '';

        return c.confirmed > 0
          ? `Bevestig je training van ${when}, moment ${c.confirmed + 1} van ${c.total}${consequence}`
          : `Bevestig je training van ${when}${consequence}`;
      },
      confirmText() {
        return 'Weet je zeker dat je de reservering op <strong><em>' + this.training_slot.start_date + '</em></strong> van <strong><em>' + this.training_slot.start_time + ' tot '+ this.training_slot.stop_time +'</strong></em> aan de <strong><em>' + this.training_slot.gym.street + '</em></strong> in <strong><em>' + this.training_slot.gym.city + '</em></strong> wil annuleren?'
      },
      stopTime() {

      }
    },

    created() {
      //
    },

    mounted() {
      //
    },

    methods: {
      /**
       * One tap on `Bevestig` (BOOK-02, 41-UI-SPEC IC3 / IC4).
       *
       * THE ROW'S OWN DATA IS NEVER MUTATED HERE. This is not optimistic: the
       * page replaces the booking's `confirmations` object from the server's
       * echo, and until it does the row shows exactly what it showed before.
       * Showing `Bevestigd` over a request that failed is the one failure mode
       * IC4 exists to rule out — it is what costs the member their slot in
       * phase 42.
       *
       * `confirming` is flipped here and cleared by the `done` callback the page
       * calls in BOTH outcomes. The page owns the request and the `source`
       * decision (the binding belongs to the navigation that opened the page,
       * which this row knows nothing about), so it is the page that knows when
       * the server answered.
       *
       * The re-entrancy guard is the REAL double-submit control: framework7
       * renders `disabled` as a CLASS, not the native attribute
       * (`button.js` classesComputed), and a class does not stop a click.
       */
      onConfirm() {
        if (this.confirming) {
          return;
        }

        this.confirming = true;

        this.$emit('confirm', {
          done: () => {
            this.confirming = false;
          },
        });
      },
      openCalendar() {
        this.showCalendarPicker = true;
      },
      async addToGoogleCalendar() {
        await openGoogleCalendar(this.training_slot);
      },
      async addToAppleCalendar() {
        await shareICS(this.training_slot);
      },
      openDoor() {
        // Let the backend do this
        // if(!this.isToday) {
        //   this.$store.dispatch('notifications/addInfoNotification', {
        //     message: 'Je bent nog iets te vroeg. Je kunt de deur 15 minuten voor de start van je training openen.',
        //     hide_after: 5000,
        //   });
        //   return;
        // }
        let vm = this;
        f7.dialog.confirm('Wil je de deur openen van de ' + this.training_slot.gym.street + ' in ' + this.training_slot.gym.city + '?', function () {
          vm.$store.dispatch('current_user/open_door', {
            gym_id: vm.training_slot.gym.id,
            training_slot_id: vm.training_slot.id,
          }).then(response => {
            vm.$store.dispatch('notifications/addSuccessNotification', {
              message: 'De deur is geopend',
            });
          });
        });


      },
      onDeleted() {
        this.$store.dispatch('training_slots/destroy', {
          training_slot: this.training_slot,
        })
        .then(training_slots => {
          this.$store.dispatch('notifications/addSuccessNotification', {
            message: 'Reservering geannuleerd',
          });
        })
        .catch(error => {

        });
      }
    },

    watch: {
      //
    }
  };
</script>
